import { render, staticRenderFns } from "./CreateContentChain.vue?vue&type=template&id=7009657a&scoped=true&"
import script from "./CreateContentChain.vue?vue&type=script&lang=js&"
export * from "./CreateContentChain.vue?vue&type=script&lang=js&"
import style0 from "./CreateContentChain.vue?vue&type=style&index=0&id=7009657a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7009657a",
  null
  
)

export default component.exports